<template>
  <div class="shortNav"><router-link to="/" >首页</router-link> > <slot></slot></div>
  
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media screen and(max-width: 679px){
  .shortNav{
    padding-left: 20px;
  }
}
@media screen and(min-width: 680px) and (max-width: 1079px){
  .shortNav{
    padding-left: 20px;
  }
}
@media screen and (min-width: 1080px){
  
}
.shortNav{
  line-height: 40px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 40px;
    a{
      color: #333;
      text-decoration: none;
      cursor: pointer;
    }
}
</style>
